module.exports = __webpack_public_path__ + "img/slide5.fa8bb6e9.png";